import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';
import type { SocialMediaAccounts } from '@studio/types';

export const root = {
  [HTTP_METHODS.PATCH]: {
    method: HTTP_METHODS.PATCH,
    url: `${CENTRAL_API_V3}/customers/@customerId/socialmedia/@channelId/sync`,
    params: {} as { channelId: string },
    response: {} as SocialMediaAccounts.Get.Response,
  },
};
